
import React, { useRef ,useMemo} from "react";
import { FiUpload } from "react-icons/fi";
import previewImage from '../../assets/img/no-images.jpg'
import "./FileUpload.css";
import { BiCross } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";

const ProfileFileUpload = ({
  label = "Upload File",
  file,
  setFile,
  previewUrl,
  accept = ".jpg,.jpeg,.png,.pdf",
  ids = "file",
}) => {
  const inputRef = useRef();


const handleFileChange = (e) => {
  const selected = e.target.files[0];
  if (!selected) return;

  const allowedTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
  ];

  if (!allowedTypes.includes(selected.type)) {
    toast.error("Only JPG, JPEG, PNG or PDF files are allowed");
    e.target.value = ""; // reset input
    return;
  }

  setFile((prev) => ({
    ...prev,
    [ids]: selected,
  }));
};

  

  const handleRemoveImage = (ids) => {
    setFile((prev) => ({
        ...prev,
        [ids]: '',
      }));
  }

  
  return (
    <div className="profile-upload">
      <div className="profile-upload-img position-relative">
       {file&& <i onClick={()=>handleRemoveImage(ids)} className="position-absolute top-0 end-0">
          <IoClose className="text-danger" size={20}/>
        </i>}
        <img
          src={
           file ? URL.createObjectURL(file):previewImage
          }
          alt="preview"
        />
      </div>

      <div className="profile-upload-content">
        <button
          type="button"
          className="profile-upload-btn"
          onClick={() => inputRef.current.click()}
        >
          <FiUpload className="me-2" />
          {label}
        </button>

        <input
          ref={inputRef}
          type="file"
          id={ids}
          accept={accept}
          hidden
          onChange={handleFileChange}
        />

        <p className="mb-1">only jpg, png, jpeg or pdf</p>

        {file && (
          <small className="file-name">{file.name}</small>
        )}
      </div>
    </div>
  );
};

export default ProfileFileUpload;
